// @flow
import TattleTale from '../util/tracking/TattleTale';
import join from 'url-join';
import AccountDAO from './AccountDAO';
import TeamDAO from './TeamDAO';
import LicensedProductsDAO from './LicensedProductsDAO';
import MediaDAO from './MediaDAO';

type DaoParams = {
  accessToken: string,
  statsUrl: string,
  reportsUrl: string,
  mediaServerUrl: string,
  fastServerUrl: string,
  accountId: string,
  fastAccountUrl: string,
};

const indexDbAvailable = window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB ||
  window.msIndexedDB || window.shimIndexedDB;

export default class DAO {
  accessToken: string;
  statsUrl: string;
  reportsUrl: string;
  fastAccountUrl: string;
  mediaServerUrl: string;
  account: AccountDAO;
  media: MediaDAO;
  teams: TeamDAO;
  licensedProducts: LicensedProductsDAO;
  logger: TattleTale;

  constructor(params: DaoParams) {
    const {
      accessToken,
      statsUrl,
      mediaServerUrl,
      reportsUrl,
      fastServerUrl,
      fastAccountUrl,
    } = params;

    this.accessToken = accessToken;
    this.statsUrl = statsUrl;
    this.reportsUrl = reportsUrl;
    this.mediaServerUrl = mediaServerUrl;
    this.fastAccountUrl = fastAccountUrl;

    // Tattletale logging instance
    if (statsUrl && accessToken) {
      this.logger = this.initializeLogger(statsUrl, accessToken);
    }

    this.account = new AccountDAO(accessToken, fastServerUrl, fastAccountUrl, this.logger);
    this.media = new MediaDAO(accessToken, mediaServerUrl, this.logger);
    this.teams = new TeamDAO(accessToken, statsUrl, this.logger);
    this.licensedProducts = new LicensedProductsDAO(accessToken, fastServerUrl, this.logger);
  }

  getLogger = () => this.logger;

  initializeLogger = (url: string, token: string) => {
    return new TattleTale(join(url, 'log'), {}, (request) => {
      request.setRequestHeader('Authorization', `Bearer ${token}`);
    });
  };
}
